<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <CidadaoIdentificacao
                :additionals="additionals"
                :data-atual="form.cidadao.dataAtual"
                :form="form.cidadao.identificacao"
                :model="model.cidadao"
                :termos-invalidos="form.cidadao.termosInvalidos"
                show-dnv
            />

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        label="E-mail"
                        placeholder="email@dominio.com.br"
                        v-model="model.email"
                        :validations="validations.email"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-area
            type="section"
            title="Telefone"
        >
            <CidadaoTelefone
                ref="CidadaoTelefone"
                :telefones="model.cidadao.telefones"
            />
        </rkm-area>

        <rkm-area
            type="section"
            title="Convênio médico"
        >
            <CidadaoConvenioMedico
                ref="CidadaoConvenioMedico"
                :conveniosMedicos="model.cidadao.conveniosMedicos"
            />
        </rkm-area>
    </div>
</template>

<script>
// Components.
import CidadaoIdentificacao from '@/components/cadastro/cidadao/Identificacao'
import CidadaoTelefone from '@/components/cadastro/cidadao/Telefone'
import CidadaoConvenioMedico from '@/components/cadastro/cidadao/ConvenioMedico'

// Mixins.
import { mask } from '@/mixins'

export default {
    components: {
        CidadaoIdentificacao,
        CidadaoTelefone,
        CidadaoConvenioMedico,
    },
    mixins: [ mask ],
    props: {
        additionals: { type: Object, required: true, default: () => ({}) },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    computed: {
        validations() {

            return {
                email: {
                    min: 5,
                    max: 100,
                    email: true,
                },
            }
        }
    },
    methods: {
        async validate() {

            return await this.$refs.Form.validate()
                && await this.$refs.CidadaoTelefone.validate()
                && await this.$refs.CidadaoConvenioMedico.validate()
        },
    }
}
</script>